export let servicesData = {
  en: {
    prepaid: {
      title: "Instant prepaid mobile Top-up",
      text:
        "Recharge any prepaid SIM easy and fast and stay connected with your beloved ones. Find reasonable packages all in SuperPay. All Operators are covered with recharge and bundle services.",
      benefitsTitle: "Benefits:",
      benefits: [
        { id: 1, text: "- Easy to purchase and easy to pay." },
        { id: 2, text: "- Covering all operator services in one app" },
        { id: 3, text: "- Covering Bundle and Recharge" },
        { id: 4, text: "- Easy to re-purchase" },
        { id: 5, text: "- Keep the history of your Top-Up purchases" },
      ],
      stepsTitle: "How to Top-up your mobile with SuperPay?",
      img: "/statics/services/prepaid/header_prepaid.jpg",
      steps: [
        {
          id: 1,
          value:
            "Enter the phone number that you are intended to recharge. Don’t forget to select your operator.",
          img: "/statics/services/prepaid/1_step_prepaid.png",
        },
        {
          id: 2,
          value: "Choose the package that is suitable for you.",
          img: "/statics/services/prepaid/2_step_prepaid.png",
        },
        {
          id: 3,
          value: "Pay and receive your package.",
          img: "/statics/services/prepaid/3_step_prepaid.png",
        },
      ],
    },
    travel: {
      title: "Arranging a memorable trip for your family so simple and easy",
      text:
        "Flight tickets, Bus tickets, Train tickets and Hotel bookings are all in SuperPay. Reserve your accommodation online and enjoy your trip. Use SuperPay to find competitive price for your trip domestic and internationally with different carriers.",
      benefitsTitle: "Benefits:",
      benefits: [
        { id: 1, text: "- Easy to use." },
        { id: 2, text: "- Comprehensive." },
        { id: 3, text: "- Competitive pricewise." },
        { id: 4, text: "- Local and International." },
        { id: 5, text: "- End to End trip accommodation." },
        { id: 6, text: "- Wide range of services." },
      ],
      stepsTitle: "How to buy a Flight ticket?",
      img: "/statics/services/travel/header_travel.jpg",
      steps: [
        {
          id: 1,
          value: "Select the service.",
          img: "/statics/services/travel/1_step_travel.png",
        },
        {
          id: 2,
          value:
            "Select Origin and destination then Choose departure date. After specifying the number of passengers, tap on search flight.",
          img: "/statics/services/travel/2_step_travel.png",
        },
        {
          id: 3,
          value: "Choose your intended flight.",
          img: "/statics/services/travel/3_step_travel.png",
        },
        {
          id: 4,
          value:
            "Enter passenger information or select from your passengers list.",
          img: "/statics/services/travel/4_step_travel.png",
        },
        {
          id: 5,
          value:
            "Check the information and if it was correct tap accept and pay button for payment. You would see the successful dekount if payment was successful.",
          img: "/statics/services/travel/5_step_travel.png",
        },
      ],
    },
    gamePin: {
      title: "E-pins for games with best price",
      text:
        "Time is very important for a real professional gamers. Buy your pin and enjoy your game as soon as possible. Use SuperPay to get competitive prices to acquire your game pin with large variety of games you love.",
      benefitsTitle: "Benefits:",
      benefits: [
        { id: 1, text: "- Easy to buy." },
        { id: 2, text: "- Competitive Price." },
        { id: 3, text: "- Covering various games." },
        { id: 4, text: "- Real time delivery." },
        { id: 5, text: "- Keep the history of the purchased pins." },
        { id: 6, text: "- Re-Purchase easily." },
      ],
      stepsTitle: "How to buy Game PIN?",
      img: "/statics/services/game-pin/header_gamepin.png",
      steps: [
        {
          id: 1,
          value: "Tap GamePIN.",
          img: "/statics/services/game-pin/1_step_pin.png",
        },
        {
          id: 2,
          value: "Search for your intended game.",
          img: "/statics/services/game-pin/2_step_pin.png",
        },
        {
          id: 3,
          value: "Check the information and tap on pay button.",
          img: "/statics/services/game-pin/3_step_pin.png",
        },
        {
          id: 4,
          value:
            "You can pay by your wallet or your credit card. If you choose pay by wallet option, it takes a few second and you can enjoy your game as soon as possible.",
          img: "/statics/services/game-pin/4_step_pin.png",
        },
      ],
    },
    billPayment: {
      title: "24/7 utility Bill Payment",
      text:
        "Pay your bills whenever you like. Use your digital wallet for paying bills with just one touch or use your saved cards list and choose one of them.",
      benefitsTitle: "Benefits:",
      benefits: [
        { id: 1, text: "- Easy to pay your bills 24/7." },
        {
          id: 2,
          text:
            "- Wide variety of bill services from Internet and Mobile to Water and Electricity.",
        },
        { id: 3, text: "- Real time payment receipt." },
        { id: 4, text: "- Re-Pay the bills conveniently." },
        { id: 5, text: "- Keep the history of your bill payments." },
      ],
      stepsTitle: "How to pay Bills with SuperPay?",
      img: "/statics/services/bill-payment/header_billpayment.png",
      steps: [
        {
          id: 1,
          value: "Touch Bill Payment icon on the main page of application.",
          img: "/statics/services/bill-payment/1_step_billpayment.png",
        },
        {
          id: 2,
          value: "Touch Add new bill.",
          img: "/statics/services/bill-payment/2_step_billpayment.png",
        },
        {
          id: 3,
          value:
            "Choose the company you are willing to pay its bill or search the name of company.",
          img: "/statics/services/bill-payment/3_step_billpayment.png",
        },
        {
          id: 4,
          value: "Enter your bill number and tap next button.",
          img: "/statics/services/bill-payment/4_step_billpayment.png",
        },
        {
          id: 5,
          value: "Check the bill information.",
          img: "/statics/services/bill-payment/5_step_billpayment.png",
        },
        {
          id: 6,
          value: "Touch Pay button and your bill is paid.",
          img: "/statics/services/bill-payment/6_step_billpayment.png",
        },
      ],
    },
    qrPayment: {
      title: "Stay safe in this critical period with QR Payment",
      text:
        "Payment system with QR code scan is a unique and useful method of payment for both Merchants and customers.",
      stepsTitle: "Learn to use the QR Payment method",
      img: "/statics/services/qr-payment/header_q_rpayment.png",
      steps: [
        {
          id: 1,
          value: "Touch the QR Code icon on the main page of the app.",
          img: "/statics/services/qr-payment/1_step_q_rpayment.png",
        },
        {
          id: 2,
          value: "Scan the QR code and pay.",
          img: "/statics/services/qr-payment/2_step_q_rpayment.png",
        },
        {
          id: 3,
          value:
            "Another way is to use Merchant or receiver code and enter it in the white field of the app.",
          img: "/statics/services/qr-payment/3_step_q_rpayment.png",
        },
        {
          id: 4,
          value:
            "Enter the amount you are willing to pay Touch the next button.",
          img: "/statics/services/qr-payment/4_step_q_rpayment.png",
        },
        {
          id: 5,
          value: "Choose the method you are going to use for payment.",
          img: "/statics/services/qr-payment/5_step_q_rpayment.png",
        },
        {
          id: 6,
          value: "Tap the next bottun and payment is done.",
          img: "/statics/services/qr-payment/6_step_q_rpayment.png",
        },
      ],
    },
    superpayWallet: {
      title: "Real-time money transfer with SuperPay Wallet",
      text:
        "No need to wait for Monday. Transfer money 24/7 with superPay wallet and enjoy your weekend.",
      stepsTitle: "What can I do with my Wallet?",
      img: "/statics/services/wallet/header_moneytransfer.png",
      steps: [
        {
          id: 1,
          value:
            "Cash out: Need money on your bank account? Cash out from you wallet 24/7 without any concern.",
          img: "/statics/services/wallet/1_step_moneytransfer.png",
        },
        {
          id: 2,
          value:
            "Cash in: Fan of speed? Charge your wallet and pay all your payments easy and fast. ",
          img: "/statics/services/wallet/2_step_moneytransfer.png",
        },
        {
          id: 3,
          value:
            "Money transfer: Tired of all time taking process? Transfer money from your wallet and enjoy living without any limits and concerns.",
          img: "/statics/services/wallet/3_step_moneytransfer.png",
        },
      ],
    },
  },
  tr: {
    prepaid: {
      title: "Aninda Cep Telefona TL Yükle",
      text:
        "Telefonunuza kolay ve hızlı şekilde TL yukleyin, hayatınıza kaldığı yerden devam edin. Tüm operatörler ve uygun fiyat paketler hepsi SuperPay'de.",
      benefitsTitle: "SuperPay kullanmanın faydaları nelerdir?",
      benefits: [
        { id: 1, text: "- Satın alması ve ödemesi kolay." },
        {
          id: 2,
          text: "- Tüm operatör hizmetlerini tek bir uygulamada kapsar",
        },
        { id: 3, text: "- İster Paket satin al İster Tl yükle" },
        { id: 4, text: "- Eksi satın aldıklarını yenıden kolayca alabilirsin" },
        { id: 5, text: "- TL yükleme Geçmişini takıp edebilirsin" },
      ],
      stepsTitle: "SuperPay ile telefonunuza nasıl TL yüklenir?",
      img: "/statics/services/prepaid/header_prepaid.jpg",
      steps: [
        {
          id: 1,
          value:
            "TL yükleme istediğiniz cep numarasını girin. Operatörünüzü seçmeyi unutmayın.",
          img: "/statics/services/prepaid/1_step_prepaid.png",
        },
        {
          id: 2,
          value: "Size uygun paketi seçin.",
          img: "/statics/services/prepaid/2_step_prepaid.png",
        },
        {
          id: 3,
          value: "Ödeme yaptıktan sonra paketi kullanabilirsiniz.",
          img: "/statics/services/prepaid/3_step_prepaid.png",
        },
      ],
    },
    travel: {
      title: "Aileniz için unutulmaz bir seyahat deneyimi sunmak çok kolay",
      text:
        "Uçak bileti, Otobüs bileti, tren bileti ve otel rezervasyonlarınızın tümünü Superpay'den yapabilirsiniz. Oteliniz ve ulaşımınız için rezervasyon yapın ve cüzdanınız veya kredi kartınızla ödeyin. Seyahatin tadını çıkarın. Farklı taşıyıcılarla yurt içi ve yurt dışı seyahatiniz için uygun fiyat bulmak için SuperPay'i kullanın.",
      benefitsTitle: "SuperPay kullanmanın faydaları nelerdir?",
      benefits: [
        { id: 1, text: "- Kullanımı kolay." },
        { id: 2, text: "- kapsamlı." },
        { id: 3, text: "- Uygun fiyatlar." },
        { id: 4, text: "- Yurtiçi ve yurtdişi." },
        { id: 5, text: "- Uçtan uca seyahat planlaması." },
        { id: 6, text: "- Seyahat için farklı hizmetleri içerir." },
      ],
      stepsTitle: "SuperPay ile uçak bileti nasıl alınır?",
      img: "/statics/services/travel/header_travel.jpg",
      steps: [
        {
          id: 1,
          value: "Uçak bilet hizmeti seçin.",
          img: "/statics/services/travel/1_step_travel.png",
        },
        {
          id: 2,
          value:
            "Kalkış ve varış noktasını seçin, ardından kalkış tarihini seçin. Yolcu sayısını belirledikten sonra, ara butona tıklayın.",
          img: "/statics/services/travel/2_step_travel.png",
        },
        {
          id: 3,
          value: "İstediğiniz uçuşu seçin.",
          img: "/statics/services/travel/3_step_travel.png",
        },
        {
          id: 4,
          value: "Yolcu bilgilerini girin veya yolcu listenizden seçin.",
          img: "/statics/services/travel/4_step_travel.png",
        },
        {
          id: 5,
          value:
            "Bilgileri kontrol edin ve doğru ise ödeme için Devam düğmesine dokunun. Ödeme başarılı olursa, başarılı mesajini görebilirsiniz.",
          img: "/statics/services/travel/5_step_travel.png",
        },
      ],
    },
    gamePin: {
      title: "En uygun oyun E-pinler",
      text:
        "Gerçek bir profesyonel oyuncu için saniyeler önemlidir.Superpay'de en uygun E-pin fiyatları bulabilirsiniz.E-Pininizi satın alın ve oyunun tadını çıkarın.",
      benefitsTitle: "SuperPay kullanmanın faydaları nelerdir?",
      benefits: [
        { id: 1, text: "- Satın alması kolay." },
        { id: 2, text: "- Uygun fiyatlar." },
        { id: 3, text: "- Çeşitli oyunları kapsayan." },
        { id: 4, text: "- Anında e-pini teslim alin." },
        { id: 5, text: "- Satın alınan pinlerin geçmişi mevcut." },
        {
          id: 6,
          text: "- Eksi satın aldıklarını yenıden kolayca alabilirsin.",
        },
      ],
      stepsTitle: "Oyun E-pini nasil alinir?",
      img: "/statics/services/game-pin/header_gamepin.png",
      steps: [
        {
          id: 1,
          value: "Oyun E-pin simgesine tiklayin.",
          img: "/statics/services/game-pin/1_step_pin.png",
        },
        {
          id: 2,
          value:
            "E-pin satın almak istediğiniz oyunu seçin veya oyun adını sorgulayın.",
          img: "/statics/services/game-pin/2_step_pin.png",
        },
        {
          id: 3,
          value: "Bilgileri kontrol edin ve ödeme butonuna tıklayın.",
          img: "/statics/services/game-pin/3_step_pin.png",
        },
        {
          id: 4,
          value:
            "SuperPay cüzdanınız veya kredi kartınız ile ödeme yapabilirsiniz.Satın almayı en hızlı şekilde tamamlamak için SuperPay cüzdanı kullanın.",
          img: "/statics/services/game-pin/4_step_pin.png",
        },
      ],
    },
    billPayment: {
      title: "7/24 Fatura ödemesi",
      text:
        "Faturanızı istediğiniz zaman ödeyin. Tek bir dokunuşla ödeme yapın.Dijital cüzdanınızı kullanın veya kayıtlı kart listenizden kart seçin. Superpay ile her işlem için farklı uygulamalara sahip olmanıza gerek yok.",
      benefitsTitle: "SuperPay kullanmanın faydaları nelerdir?",
      benefits: [
        { id: 1, text: "- 7/24 fatura ödemesi." },
        {
          id: 2,
          text:
            "- İnternet, cep telefon, doğal gaz ve elektrik fatura ödeme hizmetleri hepsi SuperPay'de.",
        },
        { id: 3, text: "- Anında ödeme fişi alabilirsiniz." },
        {
          id: 4,
          text:
            "- Ödediğiniz faturalari kaydedin ve bir dahaki sefer çabukca ödeyin.",
        },
        { id: 5, text: "- Fatura ödemelerinizin geçmişini saklayın." },
      ],
      stepsTitle: "SuperPay ile Faturalar nasıl ödenir?",
      img: "/statics/services/bill-payment/header_billpayment.png",
      steps: [
        {
          id: 1,
          value: "Uygulamanın ana sayfasında Fatura Ödeme simgesine tiklayin.",
          img: "/statics/services/bill-payment/1_step_billpayment.png",
        },
        {
          id: 2,
          value: "Yeni fatura ekle butonuna tıklayınl.",
          img: "/statics/services/bill-payment/2_step_billpayment.png",
        },
        {
          id: 3,
          value:
            "Faturasını ödemek istediğiniz kurumu seçin veya kurum adını yazarak sorgulayın.",
          img: "/statics/services/bill-payment/3_step_billpayment.png",
        },
        {
          id: 4,
          value: "Fatura numaranızı girin ve Devam butonuna tıklayın.",
          img: "/statics/services/bill-payment/4_step_billpayment.png",
        },
        {
          id: 5,
          value: "Fatura bilgilerini kontrol edin.",
          img: "/statics/services/bill-payment/5_step_billpayment.png",
        },
        {
          id: 6,
          value:
            "Ödeme butonuna tıklayın. Faturanız ödeme işleminiz tamamlandı.",
          img: "/statics/services/bill-payment/6_step_billpayment.png",
        },
      ],
    },
    qrPayment: {
      title: "QR ödeme ile bu kritik dönemde güvende kalın",
      text:
        "QR kod ile ödeme sistemi hem üye işyeri hem de kullancılar için benzersiz ve kullanışlı bir ödeme yöntemidir.",
      stepsTitle: "QR kodu ile nasıl ödeme yapabilirim?",
      img: "/statics/services/qr-payment/header_q_rpayment.png",
      steps: [
        {
          id: 1,
          value: "Uygulamanın ana sayfasındaki QR Kod simgesine dokunun.",
          img: "/statics/services/qr-payment/1_step_q_rpayment.png",
        },
        {
          id: 2,
          value: "QR kodunu tarayın.",
          img: "/statics/services/qr-payment/2_step_q_rpayment.png",
        },
        {
          id: 3,
          value:
            "Veya nu işlem için bir diğer yöntem olan 6 haneli kodu ilgili alan girin.",
          img: "/statics/services/qr-payment/3_step_q_rpayment.png",
        },
        {
          id: 4,
          value:
            'Ödemek istediğiniz tutarı girin ve "Devam" butonuna tıklayın.',
          img: "/statics/services/qr-payment/4_step_q_rpayment.png",
        },
        {
          id: 5,
          value:
            "Ödeme yapmak istediğiniz yöntemi seçin. SuperPay cüzdanı veya kartlarınızdan birini seçebilirsiniz. Ardından ödeme için onayı verin.",
          img: "/statics/services/qr-payment/5_step_q_rpayment.png",
        },
        {
          id: 6,
          value: "Devam butonuna tıkladıktan sonra ödemeniz gerçekleştiriyor.",
          img: "/statics/services/qr-payment/6_step_q_rpayment.png",
        },
      ],
    },
    superpayWallet: {
      title: "Superpay cüzdan ile anlık para transferi",
      text:
        "Pazartesi mesa, saatini beklemene gerek yok. Superpay ile 7/24 para aktarın, hafta sonunun tadını çıkarın.",
      stepsTitle: "Cüzdanımla ne yapabilirim?",
      img: "/statics/services/wallet/header_moneytransfer.png",
      steps: [
        {
          id: 1,
          value:
            "Para çekme: Banka hesabınızda paraya mı ihtiyacınız var? Herhangi bir endişe duymadan cüzdanınızdan 7/24 para çekebilirsiniz.",
          img: "/statics/services/wallet/1_step_moneytransfer.png",
        },
        {
          id: 2,
          value:
            "Bakiye yükleme: Zamanı kaybetmek istemiyorsunuz? Cüzdanınıza bakiye ekleyin ve tüm ödemelerinizi kolay ve hızlı bir şekilde ödeyin. ",
          img: "/statics/services/wallet/2_step_moneytransfer.png",
        },
        {
          id: 3,
          value:
            "Para transferi: Tüm zaman alan süreçlerden bıktınız mı? Cüzdan ile anlı para transferi yapın ve hayattın tadını çıkarın.",
          img: "/statics/services/wallet/3_step_moneytransfer.png",
        },
      ],
    },
  },
};
